import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2, { getPageWiseUserCampaignList } from "../../../../services/iqApiV2";
import { FETCH_WIN_OPPORTUNITIES_REQUEST, fetchWinOpportunitiesFailure, fetchWinOpportunitiesSuccess } from "../../actions/opportunities/winOpportunitiesActions";
import { bannerService } from "../../../../context/BannerContext";
import { normalizeMappedProducts } from "../../../../utilities/uiUtils";




async function findWinOpportunity(clientName, accountName, userId,type) {
    const data = {
      client: clientName,
      account: accountName,
      user_id: userId,
      type: type
    };
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post('/opportunities/fetch', {}, {"params" : data} );
      // console.log("response : ", response);

      // console.log('Response:', response.data);
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
export function* fetchWinOpportunitiesSaga() {
  try {
    const payload = yield select(
      (state) => state?.winOpportunitiesReducer?.payload
    );
    const { clientName, accountName, userId, type } = payload;

    // 🔹 Fetch opportunities
    const data = yield call(findWinOpportunity, clientName, accountName, userId, type);

    // 🔹 Fetch existing nurtures for MAXIMIZE_PIPE
    const dataOfExistingNurtures = yield call(
      getPageWiseUserCampaignList,
      userId
    );

    // 🔹 Create a Set for faster lookup

      const nurtureMap = new Map(
        (dataOfExistingNurtures || [])
          .filter((item) => item?.opportunity_id && item.opportunity_id !== "None")
          .map((item) => [item.opportunity_id, item.status])
      );

      console.log("spot opp existing nurtures map", nurtureMap);

      // ✅ Then use it in your normalized data
      const normalizedData = (data || []).map((item) => {
        const mappedProducts = normalizeMappedProducts(item?.mapped_products);
        const status = nurtureMap.get(item?.opportunity_id);

        return {
          ...item,
          mapped_products: mappedProducts,
          auto_nurture_in_progress: nurtureMap.has(item?.opportunity_id),
          auto_nurture_status: status || null,
        };
      });
    const enhancedData = normalizedData;

    // 🔹 Sort bookmarked items first
    const sortedData = [...enhancedData].sort((a, b) => {
      const aBookmarked = a?.is_bookmarked ? 1 : 0;
      const bBookmarked = b?.is_bookmarked ? 1 : 0;
      return bBookmarked - aBookmarked;
    });

    console.log("dataOfExistingNurtures", sortedData, dataOfExistingNurtures);

    yield put(fetchWinOpportunitiesSuccess(sortedData));
  } catch (error) {
    console.error("Error in fetchWinOpportunitiesSaga:", error);
    yield put(fetchWinOpportunitiesFailure(error.message));
  }
}
// Watcher Saga
export function* watchWinOpportunitiesSaga() {  
  yield takeLatest(FETCH_WIN_OPPORTUNITIES_REQUEST, fetchWinOpportunitiesSaga);
}
